import { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import PlTitle from "../../elements/PlTitle";


import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";

import XDateFee from "./XDateFee";
import XTime from "./XTime";



import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";


import HourRefresh from "./HourRefresh";
import XTimeByDay from "./XTimeByDay";
import AppContext from "../../AppContext";
import SortBy from "../../helpers/SortBy";
import Xlsx from "../../exporter/Xlsx";
import InputCombo from "../../helpers/InputCombo";


function Hour(props)
{


    const tabRef = useRef(0);
    const tab2Ref = useRef(0);
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''),  
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'),
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,       
        archiwalne: "0",
        limit: 50,
        page: 1,
        pages: 1,
        show: true, 
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },
    });
    const [tab, setTab] = useState(null);

    const [selectedRow, setSelectedRow] = useState([]);


      const [optionArch, setOptionArch]  = useState([
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '0',
            title: 'Dziecko aktywne'
        }, {
            v: '1',
            title: 'Dziecko w archiwum'
        }
    ]
    );


    const [gr, setGr] = useState([]);
    const fetchGr = (fTab) => {   setGr(fTab);  }


    var dt = new Date();
    const [showDay, setShowDay] = useState({
        from: dt.getDate() - 3,
        to: dt.getDate() + 3,
    });
    const [strToDay, setStrToDate] = useState( dt.toISOString().split`T`[0]  ); 


    const showAllDays = () => {

        if(showDay.from == -1)
            {
                var dt = new Date();
                setShowDay({
                    from: dt.getDate() - 3,
                    to: dt.getDate() + 3,
                });

                props.mainView.changeMenuStatus(1);
                return;
            }



        props.mainView.changeMenuStatus(0);
        setShowDay({
            from: -1,
            to: 32
        });

    }

 



    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
 
         setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
         
        
         if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }


         props.mainView.writeFilter(filedName, val);
     }



     const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {
        setFilterParam({
            d_imie_nazwisko: '', 
            p_grupa_id: '_x_',
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,         
            archiwalne: "0",
            limit: 50,
            page: 1,
            show: true,
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
        });
        setTab(null);

        
        props.mainView.writeFilter('d_imie_nazwisko', '');
 
        props.mainView.writeFilter('p_group_id', '_x_'); 
    }

    const filterApprove = () => {   
        setTab(null)     
    }


    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }



        //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//-------------------------------------------------------
//-------------------------------------------------------





    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,hour', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );     
                        
                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.p_dziecko_id,
                                title: item.imie  + "  " + item.nazwisko,
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);


                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    //param1={row.p_dziecko_id} param2={dd.dzien}  param3={row.p_typy_oplat_id} param4=''
    const onChangeXTime = (hm, param1, param2, param3, param4) =>  {

        console.log("XTime ", hm, param1, param2, param3, param4);


        props.mainView.setProgress(-2);

       
        var req = {
            p_dziecko_id: param1,
            p_typy_oplat_id: param3,
            hm: hm,
            dzien: param2
        };


        fetch( Config.url + '/rest_v1_kids,hour_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane" , "ok" , null );
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });


    }




 

    const onChangeXTimeDay = (day, hm, param1, param2, param3, param4) =>  {

        console.log("XTime ", day,  hm, param1, param2, param3, param4);



        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dziecka' ,  "ok"  ,null); 
            return;              
         }




        props.mainView.setProgress(-2);

       
        var req = {
            ids:ids,     
            hm: hm,
            dzien: day
        };


        fetch( Config.url + '/rest_v1_kids,hour_update_mass', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane" , "ok" , null );
                        getTab();
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });


    }





    if(tab == null)
    {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
    }

    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
        }





    var titleRaport = "Godziny ";
    if(filterParam.rok != '_x_') titleRaport += " " + filterParam.rok;
    if(filterParam.miesiac != '_x_') titleRaport += "-" + filterParam.miesiac;

    if(filterParam.p_grupa_id != '_x_') 
    {
        for(var p=0; p < gr.length; p++)
        {
            if(gr[p].v == filterParam.p_grupa_id)
            {
                titleRaport += " " + gr[p].title;
                break;
            }
        }
    }else  titleRaport += " wszystkie grupy" ;

  
    document.title = titleRaport;





        
    var sortList = [                         
        {column: "dziecko_nazwisko", name: "Nazwisko"  },
]


        
        var zaznaczonych = 0;
        for(var s=0; s<selectedRow.length; s++)
        {
            if(selectedRow[s].selected == 1) zaznaczonych ++;
        }


        return <div className="view_content">

              

                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 

                {
                    filterParam.show == true  &&
                    <div className="table_filter">
                
                    <div className="filter_controll">   
                        <label>Grupa: </label>                             
                        <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}  fetchTab={fetchGr}  valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                    </div> 


                    
                    <div className="filter_controll">   
                        <label>Dziecko: </label>                             
                        <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                    </div>  

                    <div className="filter_controll">   
                                    <label>Archiwum: </label>                             
                                    <InputCombo   userData={props.userData} value={filterParam.archiwalne} items={optionArch}  valChange={valChangeListener} goNext={goNextNew} name="archiwalne" placeholder={"Archiwalne: "}   />
                            </div> 
                 

                    <div className="filter_controll">   
                        <label>Rok: </label>                             
                        <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                    </div> 

                    <div className="filter_controll">   
                        <label>Miesiąc: </label>                             
                        <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                    </div> 


                    <div className="filter_btn">
                        <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                        <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                    </div>

                </div>
                } 

              


                 <div className="table_widget">    
               


                    <HourRefresh userData={props.userData} mainView={props.mainView}  onSuccess={getTab} />

                    &nbsp;&nbsp;
                    <span className="link_color" onClick={showAllDays}>Zmień widok</span>
                    &nbsp;&nbsp;

                   

                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                    <Csv tabRef={tabRef} title={ titleRaport + ".csv" } />                  
                    <Xlsx tabRef={tabRef} title={titleRaport  + ".csv"} />                  
                    <Print tabRef={tabRef} title={titleRaport + ".csv" } />

                    <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  

                </div>

                <div className="table_mass">  
                                    <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
                                    &nbsp;
                                    <XTimeByDay title={ "Zmień dla wybranych pozycji ("  + zaznaczonych + ")" }   mainView={props.mainView} onChange={onChangeXTimeDay} param1={zaznaczonych} param2={1}  param3={1} param4='' />                                                            
                </div>


           
                                                                                     
                    <div className="gohide">
                    <table ref={tabRef} >
                                                    <thead>
                                                        <tr className="header">
                                                            <td className="td_left">LP</td>                                                 
                                                                                    
                                                            <td>Dziecko</td>  
                                                            <td>Stawka</td>         
                                              

                                                            {
                                                                tab.map( (row, ix) => {

                                                                    if(ix > 0) return null;

                                                                    return (
                                                                        row.dni.map( (dd, ir) => {
                                                                        
                                                                            if(ir < showDay.from) return <td></td>

                                                                            if(ir > showDay.to)   return <td></td>

                                                                            return (
                                                                                <td>{ir+1} </td>
                                                                            )
                                                                        } )
                                                                    )
                                                                

                                                                } )
                                                            }

                                                        
                                                            <td>Il.</td>
                                                            <td>St.</td>
                                                            <td className="td_right">Kw.</td>

                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                            {
                                                                                                              

                                                                tab.map( (row, ix) => {
                                                                    
                                                                    var iloscRoz   = 0;
                                                                    var razemKwota = 0;
                                                             
                                                            
                                                                    if(row.umowa_od == null || row.umowa_od == undefined) row.umowa_od = " -- ";
                                                                    if(row.umowa_do == null || row.umowa_do == undefined) row.umowa_do = " -- ";
                                                                    var info = "Umowa nr " + row.numer_umowy + " (umowa od: "+row.umowa_od+" - "+row.umowa_do+" )";

                                                                    if(row.sposob_naliczania_godzin == 'r')
                                                                    {
                                                                        info = info + ", za każdą rozpoczętą godzinę";
                                                                    }

                                                                    if(row.sposob_naliczania_godzin == '0')
                                                                        {
                                                                            info = info + ", naliczanie proporcjonalne";
                                                                        }


                                                                        var isChecked = "";

                                                                        for(var s=0; s<selectedRow.length; s++)
                                                                            {
                                                                                if( selectedRow[s].id == row.p_dziecko_id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                                            }


                                                                            var rowStyle = " row ";
                                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
                                                                            

                                                                    return (
                                                                        <tr className={rowStyle}>
                                                                            <td className="gocenter" >{ix+1}</td>                                                  



                                                                            <td >{row.nazwisko + " " + row.imie}</td>  
                                                                            <td >{row.stawka}</td>    
                                                              

                                                                            {
                                                                                row.dni.map( (dd, ir) => {

                                                                                    razemKwota = parseFloat( razemKwota + dd.naliczona_kwota ) ; 
                                                                                    iloscRoz = parseFloat( iloscRoz + dd.czas_naliczony ) ; 
                                                                 

                                                                                    var clsTD = " e_square_center ";
                                                                                    var clsSquare = "e_ob_def";


                                                                                    if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                                    if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                                    if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                                    if(dd.dzien == strToDay)     clsTD = clsTD + " e_squere_today ";

                                                                                    if(dd.aktywna == '0')
                                                                                    {
                                                                                        clsSquare = "e_black";

                                                                                        return <td className="txtcloud">
                                                                                            --:--                                                                                           
                                                                                        </td>
                                                                                    }

                                                                                

                                                                           

                                                                                    if(dd.czas_naliczony > 0) clsTD = clsTD + " txt_show ";
                                                                           

                                                                                    var info = row.imie + " " + row.nazwisko + "<br/>" + dd.dzien+ "<br/>" + dd.czas.g+":" + dd.czas.m;

                                                                               
                                                                                    return <td className={clsTD + " txtcloud link_normal "} title={dd.naliczona_kwota}>                                                                                                                                                                        
                                                                                           {dd.czas.g}:{dd.czas.m}                                                                                   
                                                                                    </td>
                                                                                
        
                                                                                } )

                                                                            
                                                                            
                                                                            } 
                                                                            <td  className="goright gobold">{ (parseFloat(iloscRoz).toFixed(2)).replace(".",",") }</td>   
                                                                            <td  className="goright gobold">{ (parseFloat(row.kwota_netto).toFixed(2)).replace(".",",") }</td>   
                                                                            <td  className="goright gobold">{ (parseFloat(razemKwota).toFixed(2)).replace(".",",") }</td>

                                                                        </tr>
                                                                    )


                                                                  

                                                                 

                                                                } )
                                                            }


                                                            
        

                                                    </tbody>

                            </table>
                    </div>


                 <div className=" bg_center">

                    <div className="scorll_x">
                         <table className="table"  >
                                                    <thead>
                                                        <tr className="header">
                                                            <td className="td_left">LP</td>                                                 
                                                            <td className="link_normal" onClick={changeSelectedAll}>Z</td>                                                 
                                                            <td>Dziecko</td>  
                                                            <td>Stawka</td>         
                                                            <td> </td>  

                                                            {
                                                                tab.map( (row, ix) => {

                                                                    if(ix > 0) return null;

                                                                    return (
                                                                        row.dni.map( (dd, ir) => {
                                                                        
                                                                            if(ir < showDay.from) return <td></td>

                                                                            if(ir > showDay.to)   return <td></td>

                                                                            return (
                                                                                <td>{ir+1} </td>
                                                                            )
                                                                        } )
                                                                    )
                                                                

                                                                } )
                                                            }

                                                        
                                                            <td>Il.</td>
                                                            <td>St.</td>
                                                            <td className="td_right">Kw.</td>

                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                            {
                                                                                                              

                                                                tab.map( (row, ix) => {
                                                                    
                                                                    var iloscRoz   = 0;
                                                                    var razemKwota = 0;
                                                             
                                                            
                                                                    if(row.umowa_od == null || row.umowa_od == undefined) row.umowa_od = " -- ";
                                                                    if(row.umowa_do == null || row.umowa_do == undefined) row.umowa_do = " -- ";
                                                                    var info = "Umowa nr " + row.numer_umowy + " (umowa od: "+row.umowa_od+" - "+row.umowa_do+" )";

                                                                    if(row.sposob_naliczania_godzin == 'r')
                                                                    {
                                                                        info = info + ", za każdą rozpoczętą godzinę";
                                                                    }

                                                                    if(row.sposob_naliczania_godzin == '0')
                                                                        {
                                                                            info = info + ", naliczanie proporcjonalne";
                                                                        }


                                                                        var isChecked = "";

                                                                        for(var s=0; s<selectedRow.length; s++)
                                                                            {
                                                                                if( selectedRow[s].id == row.p_dziecko_id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                                            }


                                                                            var rowStyle = " row ";
                                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
                                                                            

                                                                    return (
                                                                        <tr className={rowStyle}>
                                                                            <td className="gocenter" >{ix+1}</td>                                                  


                                                                            <td className="gocenter">
                                                                                <input type="checkbox" atr-id={row.p_dziecko_id} onChange={changeSelected} checked={isChecked} />
                                                                            </td> 

                                                                            <td >{row.nazwisko + " " + row.imie}</td>  
                                                                            <td >{row.stawka}  <sup class="quick_tip" title={info}>&nbsp;?&nbsp;</sup> </td>    
                                                                            <td className="gocenter"><XDateFee userData={props.userData}  mainView={props.mainView} p_umowa_oplaty_id={row.p_umowa_oplaty_id} onClose={getTab} /></td>

                                                                            {
                                                                                row.dni.map( (dd, ir) => {

                                                                                    razemKwota = parseFloat( razemKwota + dd.naliczona_kwota ) ; 
                                                                                    iloscRoz = parseFloat( iloscRoz + dd.czas_naliczony ) ; 
                                                                
                                                                                    if(ir < showDay.from) return <td></td>
                                                                                    if(ir > showDay.to)   return <td></td>

                                                                                    var clsTD = " e_square_center ";
                                                                                    var clsSquare = "e_ob_def";


                                                                                    if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                                    if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                                    if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                                    if(dd.dzien == strToDay)     clsTD = clsTD + " e_squere_today ";

                                                                                    if(dd.aktywna == '0')
                                                                                    {
                                                                                        clsSquare = "e_black";

                                                                                        return <td className="txtcloud">
                                                                                            --:--
                                                                                            <div className="info_content">
                                                                                                <span className="info_cloud shadowx" dangerouslySetInnerHTML={{__html: "Stawka nieaktywna" }}   >                                                                                                  
                                                                                                </span>
                                                                                            </div>  
                                                                                        </td>
                                                                                    }

                                                                                

                                                                           

                                                                                    if(dd.czas_naliczony > 0) clsTD = clsTD + " txt_show ";
                                                                           

                                                                                    var info = row.imie + " " + row.nazwisko + "<br/>" + dd.dzien+ "<br/>" + dd.czas.g+":" + dd.czas.m;

                                                                               
                                                                                    return <td className={clsTD + " txtcloud link_normal "} title={dd.naliczona_kwota}>
                                                                                                                                                                        

                                                                                        <XTime title={ row.imie + " " + row.nazwisko + " - " + dd.dzien } hour={dd.czas.g} minute={dd.czas.m}  onChange={onChangeXTime} param1={row.p_dziecko_id} param2={dd.dzien}  param3={row.p_typy_oplat_id} param4='' />
                                                                                     
                                                                                        <div className="info_content">
                                                                                             <span className="info_cloud shadowx" dangerouslySetInnerHTML={{__html: info }}   >                                                                                                  
                                                                                             </span>
                                                                                        </div>                                                                                      
                                                                               
                                                                                    </td>
                                                                                
        
                                                                                } )

                                                                            
                                                                            
                                                                            } 
                                                                            <td  className="goright gobold">{ (parseFloat(iloscRoz).toFixed(2)).replace(".",",") }</td>   
                                                                            <td  className="goright gobold">{ (parseFloat(row.kwota_netto).toFixed(2)).replace(".",",") }</td>   
                                                                            <td  className="goright gobold">{ (parseFloat(razemKwota).toFixed(2)).replace(".",",") }</td>

                                                                        </tr>
                                                                    )


                                                                  

                                                                 

                                                                } )
                                                            }


                                                            
        

                                                    </tbody>

                            </table>
                    </div>
                    
                 </div>


        </div>  

}

export default Hour;